<template>
  <div class="ec-sort mr-md-2 mt-0 mt-md-3">
    <div class="col-right mr-md-2 d-inline" role="group" aria-label="Sort Dropdown">
      <div class="btn-group ec-sort-new" role="group">
       <button class="sort-simple"
                id="btnGroupDrop1" type="button" data-toggle="dropdown" aria-expanded="false">
          <div class="pl-2 h-100 d-flex align-items-center">
            <span class="mr-2 d-none d-md-inline">
            {{ sortLabel }} 
            </span>
            <span class="d-none d-md-inline mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-down" viewBox="0 0 16 16">
            <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
            </svg>
            </span>
             <span class="d-inline d-md-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-sort-down" viewBox="0 0 16 16">
            <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
            </svg>
            </span>
          </div>
          <!-- <div class="ecl-select__icon ecl-select__icon-Sort">
            <svg class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape" focusable="false" aria-hidden="true">
              <use xlink:href="@/assets/img/ecl/icons.svg#corner-arrow"></use>
            </svg>
          </div> -->
        </button>
        <ul class="dropdown-menu ec-ds-dropdown-items" aria-labelledby="btnGroupDrop1">
          <button class="dropdown-item" @click="setSortMethod('modified', 'desc', 'message.sort.lastUpdated')">
            {{ $t("message.sort.lastUpdated") }}
          </button>
          <button class="dropdown-item" @click="setSortMethod('relevance', 'desc', 'message.sort.relevance')">
            {{ $t("message.sort.relevance") }}
          </button>
          <button class="dropdown-item" @click="setSortMethod(`title.${$route.query.locale}`, 'asc', 'message.sort.nameAZ')">
            {{ $t("message.sort.nameAZ") }}
          </button>
          <button class="dropdown-item" @click="setSortMethod(`title.${$route.query.locale}`, 'desc', 'message.sort.nameZA')">
            {{ $t("message.sort.nameZA") }}
          </button>
          <button class="dropdown-item" @click="setSortMethod('issued', 'desc', 'message.sort.lastCreated')">
            {{ $t("message.sort.lastCreated") }}
          </button>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getMostLike, getDataset } from '../../../services/commentsAndLikesAPIService';

export default {
  name: "SearchSortDropdown",
  props: {
    config: Object
  },
  data() {
    return {
      sortSelected: "",
    }
  },
  computed: {
    sortTriggerId() {
      return this.$store.state.search.sortTriggerId;
    },
    getSortType() {
      return this.$store.getters["search/getSortType"];
    },
    sortLabel() {
      const sortType = this.getSortType || '';
      const firstSort = sortType.split(',')[0].trim();

      switch (firstSort) {
        case '':
        case 'relevance':
        case 'relevance+desc':
          return this.$t("message.sort.relevance");
        case 'modified+desc':
          return this.$t("message.sort.lastUpdated");
        case `title.${this.$route.query.locale}+asc`:
          return this.$t("message.sort.nameAZ");
        case `title.${this.$route.query.locale}+desc`:
          return this.$t("message.sort.nameZA");
        case 'issued+desc':
          return this.$t("message.sort.lastCreated");
        default:
          return this.$t("message.sort.relevance");
      }
    }
  },
  watch: {
    sortSelected: {
      handler(sort) {
        this.$router
          .replace({ query: Object.assign({}, this.$route.query, { sort }) })
          .catch((error) => {
            console.error(error);
          });
        this.setSort(sort);
      },
      deep: true,
    },
    sortTriggerId() {
      if (this.getSortType === 'mostLiked') {
        this.sortMostLiked();
      }
    }
  },
  methods: {
    setSort(sort) {
      this.$store.dispatch(`${this.config.setSort[0]}/${this.config.setSort[1]}`, sort);
    },
    initSort() {
      let sort = this.$route.query.sort;
      if (sort) {
        sort = sort.split(",")[0].toLowerCase();
        if (sort.includes("title")) {
          const direction = sort.includes("desc") ? "desc" : "asc";
          const labelKey = direction === "desc" ? "message.sort.nameZA" : "message.sort.nameAZ";
          this.setSortMethod(`title.${this.$route.query.locale}`, direction, labelKey);
        } else {
          const map = {
            "relevance+desc": ["relevance", "desc", "message.sort.relevance"],
            "modified+desc": ["modified", "desc", "message.sort.lastUpdated"],
            "issued+desc": ["issued", "desc", "message.sort.lastCreated"],
          };
          if (map[sort]) {
            const [method, order, labelKey] = map[sort];
            this.setSortMethod(method, order, labelKey);
          }
        }
      } else {
        this.setSort(`relevance+desc, modified+desc, title.${this.$route.query.locale}+asc`);
      }
    },
    setSortMethod(method, order) {
      this.$store.dispatch("search/setSortType", "");
      if (method === "relevance")
        this.sortSelected = `${method}+${order}, modified+desc, title.${this.$route.query.locale}+asc`;
      else if (method === "modified")
        this.sortSelected = `${method}+${order}, relevance+desc, title.${this.$route.query.locale}+asc`;
      else if (method === `title.${this.$route.query.locale}`)
        this.sortSelected = `${method}+${order}, relevance+desc, modified+desc`;
      else if (method === "issued")
        this.sortSelected = `${method}+${order}, relevance+desc, title.${this.$route.query.locale}+asc`;

      this.$store.dispatch("search/setSortType", this.sortSelected);

      this.$store.dispatch("datasets/loadDatasets", {
        locale: this.$route.query.locale,
        fields: this.$route.query.fields,
        minDate: this.$route.query.minDate,
        maxDate: this.$route.query.maxDate,
      });

      return this.sortSelected;
    },
    async sortMostLiked(page = null) {
      this.sortSelected = "";
      const currentPage = page || Number(sessionStorage.getItem("mostLikedPage") || 1);
      const baseUrl = this.$env.content.datasetDetails.ratingServiceUrl;
      const searchUrl = this.$env.api.baseUrl;
      const limit = Number(this.$store.getters["datasets/getLimit"]) || 10;
      const offset = (currentPage - 1) * limit;

      let liked = this.$store.state.search.mostLikedAll;

      if (!liked || liked.length === 0) {
        try {
          const response = await getMostLike(baseUrl, null, null, null);
          liked = response.data;
          this.$store.commit("search/SET_MOST_LIKED_ALL", liked);
        } catch (e) {
          console.error("Error in getMostLike:", e);
          return [];
        }
      }

      const currentSlice = liked.slice(offset, offset + limit);

      const datasetPromises = currentSlice.map(async item => {
        try {
          const result = await getDataset(searchUrl, item.resourceId);
          return result?.result || null;
        } catch (e) {
          console.error(`Error getting dataset ${item.resourceId}`, e);
          return null;
        }
      });

      const datasetsWithLikes = (await Promise.all(datasetPromises))
        .filter(Boolean)
        .map(d => ({
          ...d,
          distributionFormats: Array.isArray(d?.distributionFormats) ? d.distributionFormats : []
        }));

      console.log("datasetsWithLikes:", datasetsWithLikes);
      this.$store.dispatch("search/setLikedDatasets", datasetsWithLikes);
      this.$store.commit("search/SET_IS_MOST_LIKED_MODE", true);
      this.$store.commit("search/SET_MOST_LIKED_PAGE", currentPage);
      this.$store.dispatch("search/setSortType", "mostLiked");
    }
  },
  created() {
    this.$nextTick(() => {
      this.initSort();
      if (this.$route.query.mostLiked === "true") {
        const storedPage = Number(sessionStorage.getItem("mostLikedPage") || 1);
        this.sortMostLiked(storedPage);
      }
    });
  }
};
</script>

<style lang="scss" scoped>

.sort-simple {
  border: none;
  background: no-repeat;
  padding: 0px;
  margin-top: 40px !important
}

.ec-sort-new {
  height: 48px
}

.col-responsive {
  @media (min-width: 768px) {
    flex: 1 0 0%;
    width: 100%;
  }
}

.dropdown-menu {
    border-radius: 4px !important;
    margin-top: 20px !important;
}

.ec-ds-dropdown-items .nav-item .router-link-active {
  background-color: #0e47cb !important;
  color: #fff !important;
}
 
.ec-ds-dropdown-items .nav-item .router-link-active {
  background-color: #0e47cb !important;
  color: #fff !important;
}

.dropdown-item {
  padding: 7px 16px;
  &:active {
    background-color: var(--dropdown-item-active-bg);
  }
}

@media screen and (max-width: 767.5px) {
  .ec-ds-dropdown-items {
    width: 100% !important;
    right: 0 !important;
    margin-top: 45px !important;
    transform: translateX(-100%) !important;
    margin-left: 100% !important;
  }
    .sort-simple {
    border: none;
    background: no-repeat;
    padding: 0px;
    margin-top: 10px !important ;
  }
}
</style>
